import React from 'react'

export const isRef = (obj: unknown): boolean => {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    Object.prototype.hasOwnProperty.call(obj, 'current')
  )
}

export function unRef<T = HTMLElement>(target: React.RefObject<T>): T {
  const element = isRef(target)
    ? (target as React.MutableRefObject<T>).current
    : (target as T)

  return element
}
